// Thirdparty
import React, {useState, useEffect, useRef} from 'react';
import ReactDom from 'react-dom';
// Configuration
//import AuthConfig from './../configuration/auth.json';
// Styles
import './../styles/Modal.css';
import './../styles/LoginModal.css';
// Services
const Routes = require("./../services/routes.js");

function setIdRedirect(result){
  // Do not store any user data in localStorage, instead the server will send it as a signed cookie.
  if(typeof result.verified !== 'undefined'){
    localStorage.verified = result.verified;
  }
  else{
    localStorage.removeItem('verified');
  }
  
  // redirect the page to 2fa if not verified otherwise home.
  if(result.verified !== undefined && !result.verified){
    window.location = "/2fa";
    return;
  }

  window.location = "/";
}

function showErrorMessage(message){
  document.getElementById("login-errorMessage").style.display = "inline";
  document.getElementById("login-errorMessage").innerText = "* " + message;
}

// Function to login. Fetch API to server.
async function fetchLogin(user){
  try{
    const url = Routes.getAuthURL() + "/login";
    const origin = window.location.origin;
    console.log(`Sending message to ${url} with origin ${origin}`);

    const response = await fetch(
      url,
      {
        method: "POST",
        headers: {"content-type": "application/json"},
        credentials: "include",
        body: JSON.stringify(user),
      }
    );
    const result = await response.json();
    
    // Failure
    if(!response.ok) {
      showErrorMessage(result.message);
      return;
    }
    // Check for redirect
    else if (result.redirect){
      localStorage.removeItem('verified');
      window.location = result.url;
      return;
    }
    
    setIdRedirect(result);
  }
  catch(err){
    console.error("Error logging in:", err);
  }
}

// Function to signup. Fetch API to server.
async function fetchSignup(user){
  try{
    const url = Routes.getAuthURL() + "/signup";
    const origin = window.location.origin;
    console.debug(`Sending message to ${url} with origin ${origin}`);

    const response = await fetch(
      url,
      {
        method: "POST",
        headers: {"content-type": "application/json"},
        credentials: "include",
        body: JSON.stringify(user),
      }
    );
    const result = await response.json();

    // Failure
    if(!response.ok){
      showErrorMessage(result.message);
      return;
    }
    // Redirect
    else if (result.redirect){
      localStorage.removeItem('verified');
      window.location = result.url;
      return;
    }

    // Success
    setIdRedirect(result);
  }
  catch(err){
    console.error("Failed fetch signup: ", err);
  }
}

// Function to logout. Fetch API to server.
async function fetchLogout(){
  try{
    const url = Routes.getAuthURL() + "/logout";
    const origin = window.location.origin;
    console.debug(`Sending logout message to ${url} with origin ${origin}`);
    
    const response = await fetch(
      url,
      {
        method: "GET",
        headers: {"content-type": "application/json"},
        credentials: "include",
      }
    );
    console.log(`Fetch message returned ${response.status}: ${response.statusText}`);
    const result = await response.json();
    console.log(`Fetch message result ${JSON.stringify(result)}`);
    
    // Failure
    if(!response.ok){
      // If the response was unauthorized
      if(response.status===401){
        localStorage.removeItem('verified'); // Remove verified
        window.location = `/`; // redirect the page to the home page.
      }

      showErrorMessage(result.message);
      return;
    }
    // Redirect
    else if (result.redirect){
      localStorage.removeItem('verified');
      window.location = result.url;
      return;
    }

    // Success
    setIdRedirect(result);
  }
  catch(err){
    console.error("Failed logging out:", err);
  }
}

function LoginModal({open, children, onClose}) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [username, setUserName] = useState('');
  // modal state: false=login true=signup
  const [state, setState] = useState(false);

  // Ref for the modal element
  const modalRef = useRef(null);

  useEffect(()=>{
    // If the modal is to be opened to signup form
    setState(open[1]);

    // Function to handle clicks outside the modal
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose(); // Close the modal if click is outside
      }
    };

    // Add event listener
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup event listener on component unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose, open]);

	// Open display if the login modal has been opened.
	if(!open[0]){
		return null;
  }

  function Signup(){
    document.getElementById("login-errorDiv").style.margin = "300px auto";
    document.getElementById("login-errorMessage").style.display = "none";
    setState(true);
  }
  
  function Login(){
    document.getElementById("login-errorDiv").style.margin = "225px auto";
    document.getElementById("login-errorMessage").style.display = "none";
    setState(false);
  }
  
  const onLogin = (e) =>{
    e.preventDefault()
    console.log('login');
    
    fetchLogin({email, password});
  }
  
  const onSignup = (e) =>{
    e.preventDefault()
    console.log('signup');

    fetchSignup({email, password, username});
  }
  
  const onLogout = (e) =>{
    e.preventDefault()
    console.log('logout');

    localStorage.removeItem('verified');
    fetchLogout();
  }

  if(localStorage.verified !== undefined){
    return ReactDom.createPortal(
      <>
        <div className="modal-overlay"/>
        <div className="modal logout-modal" ref={modalRef}>
          <button className="login-close" onClick={onClose}>X</button>

          <div className="login-input-group">
            <button type="button" className="login-submit-btn" onClick={onLogout}>LOGOUT</button>
          </div>

          {children}
        </div>
      </>,
      document.getElementById('portal')
    )
  }
  else {
    return ReactDom.createPortal(
      <>
        <div className="modal-overlay"/>
        <div className="modal login-modal" ref={modalRef}>
          <button className="login-close" onClick={onClose}>X</button>

          <div className="login-button-box">
            <div className={`lm-btn ${state?"btn-signup":"btn-login"}`}></div>
            <button type="button" className={`login-toggle-btn ${state?"login-btn-inactive":"login-btn-active"}`} onClick={Login}>Login</button>
            <button type="button" className={`login-toggle-btn ${state?"signup-btn-active":"signup-btn-inactive"}`} onClick={Signup}>Signup</button>
          </div>

          <form className={`login-input-group ${state?"login-inactive":"login-active"}`} onSubmit={onLogin}>
            <input type="email" className="login-input-field" placeholder="Type your email"  value={email} onChange={(e) => setEmail(e.target.value)} required />
            <input type="password" className="login-input-field" placeholder="Type your password" value={password} onChange={(e) => setPassword(e.target.value)} required />
            <input type="submit" className="login-submit-btn" value='LOGIN'/>
          </form>

          <form className={`login-input-group ${state?"signup-active":"signup-inactive"}`} onSubmit={onSignup}>
            <input type="text" className="login-input-field" placeholder="Enter a username" value={username} onChange={(e) => setUserName(e.target.value)} required />
            <input type="email" className="login-input-field" placeholder="Type your email" value={email} onChange={(e) => setEmail(e.target.value)} required />
            <input type="password" className="login-input-field" placeholder="Type your password" value={password} onChange={(e) => setPassword(e.target.value)} required />
            <input type="submit" className="login-submit-btn" value='SIGNUP'/>
          </form>

          <div id="login-errorDiv">
            <p id="login-errorMessage">
              * Error message pending.
            </p>
          </div>

          {children}
        </div>
      </>,
      document.getElementById('portal')
    )
  }
}

export default LoginModal;
